// extracted by mini-css-extract-plugin
export default {"name":"contact-web_name__uHqBr","email":"contact-web_email__RulPJ","dropdownBox":"contact-web_dropdownBox__-Z-Rl","dropdownList":"contact-web_dropdownList__xxJ4k"};